import PropTypes from 'prop-types';

export const customerPropType = PropTypes.shape({
	actionColor: PropTypes.string,
	activeLanguageId: PropTypes.number,
	defaultLanguageId: PropTypes.number,
	languages: PropTypes.arrayOf(
		PropTypes.shape({
			cultureCode: PropTypes.string,
			icon: PropTypes.string,
			id: PropTypes.number,
			isActive: PropTypes.bool,
			isDefault: PropTypes.bool,
			languageCode: PropTypes.string,
			name: PropTypes.string,
		}),
	),
	logo: PropTypes.shape({
		imageUrl: PropTypes.string,
		location: PropTypes.string,
	}),
	mainColor: PropTypes.string,
	mainColorHover: PropTypes.string,
	theme: PropTypes.string,
});
